import { Col, Container, Row, Stack } from "react-bootstrap";
import { renderSortIcon } from "../helperRenders";
import RATooltip from "../RATooltip";

export default function PredictorHeader({ sortConfig, requestSort }) {
    return (
        <Container fluid>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none h-100">
                <Col xs={2} xl onClick={requestSort ? () => requestSort("song.artist") : null} className=" align-self-center">
                    <Stack direction="horizontal">
                        <span>Artist</span>
                        <span className="col-1">{renderSortIcon("song.artist", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl onClick={requestSort ? () => requestSort("song.title") : null} className=" align-self-center">
                    <Stack direction="horizontal">
                        <span>Title</span>
                        <span className="col-1">{renderSortIcon("song.title", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={2} onClick={requestSort ? () => requestSort("song_birth") : null} className=" align-self-center">
                    <Stack direction="horizontal" className="justify-content-center">
                        <span className="offset-1 text-center d-flex flex-wrap-reverse justify-content-center column-gap-1">
                            Song Birth
                            <RATooltip>The date where this song was first played 5 or more times within your own airplay market.</RATooltip>
                        </span>
                        <span className="col-1">{renderSortIcon("song_birth", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={2} onClick={requestSort ? () => requestSort("market_spins") : null} className=" align-self-center">
                    <Stack direction="horizontal" className=" justify-content-center">
                        <span className="offset-1 text-center d-flex flex-wrap-reverse justify-content-center column-gap-1">
                            Market Spins
                            <RATooltip>The amount of spins in the most recent week within your predictor market</RATooltip>
                        </span>
                        <span className="col-1">{renderSortIcon("market_spins", sortConfig)}</span>
                    </Stack>
                </Col>
                <Col xs={2} xl={1} onClick={requestSort ? () => requestSort("stars") : null} className=" align-self-center">
                    <Stack direction="horizontal" className=" justify-content-center">
                        <span className="offset-1 text-center d-flex flex-wrap-reverse justify-content-center column-gap-1">
                            Stars
                            <RATooltip>The rating of the song, with 3 stars being the best.</RATooltip>
                        </span>
                        <span className="col-1">{renderSortIcon("stars", sortConfig)}</span>
                    </Stack>
                </Col>
            </Row>
        </Container>
    );
}
